import Vue from 'vue'
import App from './App'
import router from './router'//引用路由
import ElementUI from 'element-ui';//引入element组件
import Qs from 'qs'
import $ from 'jquery';//引用jQuery
import common from '@/common/js/common';
import VueQuillEditor from 'vue-quill-editor';//富文本插件
import './common/js/request';//引入请求方法的js
import store from './store/index.js'; //vuex

Vue.prototype.$common= common;//注册公用JS
Vue.prototype.$QS = Qs;//注册QS
Vue.prototype.$VueX = store;//挂载vuex


//引入插件样式
import './common/css/reset.css';//重定向样式
import './common/css/animate.min.css';//引入动画css文件
import 'element-ui/lib/theme-chalk/index.css';
import './common/scss/style.scss';// 编译pc版所有的scss文件
import 'quill/dist/quill.core.css';//富文本插件
import 'quill/dist/quill.snow.css';//富文本插件
import 'quill/dist/quill.bubble.css';//富文本插件






// 注册全局组件
import Header  from '@/components/Header.vue';//引入头部组件
Vue.component('Header',Header);
import Footer  from '@/components/Footer.vue';//引入头部组件
Vue.component('Footer',Footer);




//注册使用插件
Vue.use(ElementUI);
Vue.use(VueQuillEditor);//富文本插件注册
Vue.config.productionTip = false;

//全局定义一个可控制的console方法
Vue.prototype.$log=(res)=>{
  if(process.env.NODE_ENV == 'production'){
    return;
  }else{
    console.log(res);
  }
}



/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js